module.exports = __webpack_public_path__ + "assets/on-view.6ece4781.svg";